var _style, _path, _polygon, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneoutgoing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8 c0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26 C29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3 l-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20,4 20,6 24.6,6 18,12.6 19.4,14 26,7.4 26,12 28,12 28,4 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_x3C_Transparent_Rectangle_x3E__250_",
    x: 0,
    className: "st1",
    width: 32,
    height: 32
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneoutgoing);
export default __webpack_public_path__ + "static/media/phoneoutgoing.f3ffdc487903b1f9db0301aa071554ab.svg";
export { ForwardRef as ReactComponent };